export enum CUSTOMER_SUPPORT_INFORMATION_FORMAT {
  TEXT = 1,
  LINK = 2,
  EXCEL_TABLE = 3,
  ELECTRICAL_RECORDING_SCHEDULE = 57,
  ELECTRICITY_PAYMENT_LOCATION = 58
}
